exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-gallery[data-v-3a739bc6]{text-align:center;width:100%;height:100%;display:grid;-ms-flex-align:center;align-items:center;min-height:calc(90vw * 1.15)}@media only screen and (min-width: 768px){.media-gallery[data-v-3a739bc6]{min-height:initial;-ms-flex-align:initial;align-items:initial}}.media-gallery--loaded[data-v-3a739bc6]{background-image:none}@media (max-width: 767px){.media-gallery .image-box[data-v-3a739bc6]{width:initial}}\n", ""]);

// exports
